import React from 'react'
import { Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer'
import { baseDocument } from '../../../utils/constants/misc'
import {
  CGV,
  CustomerAddress,
  DocumentDate,
  Footer,
  Header,
  style,
  Subject,
  TableBody,
  TableHead,
  TableTotal
} from '../../document/DocumentPDF'

const CreditNotePDF = ({ creditNote_param: creditNote, company_param: company, settings, logo_param: img }) => {
  const customer = creditNote.customer
  const styles = StyleSheet.create(style)

  const References = () => {
    if (creditNote) {
      return (
        <>
          <View style={styles.rightContainer}>
            <Text style={styles.boldWithSpace}>Référence avoir</Text>
            <Text style={styles.address}>{creditNote.creditNote_number}</Text>
          </View>
          {creditNote.quote_id !== null && creditNote.quote !== undefined && (
            <View style={styles.rightContainerNoMT}>
              <Text style={styles.boldWithSpace}>Référence devis</Text>
              <Text style={styles.address}>{creditNote.quote.quote_number}</Text>
            </View>
          )}
        </>
      )
    }
  }

  const CreditNotePayment = () => (
    <View style={{ marginTop: 20 }}>
      <Text style={styles.conditions}>
        {customer.customer_type === 2
          ? `Règlement par : ${settings.creditNote_methods.replaceAll(',', ', ')}`
          : `Règlement par : ${settings.creditNote_methods_pro.replaceAll(',', ', ')}`}
      </Text>
    </View>
  )

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View fixed>
          <Header img={img} styles={styles} title={'AVOIR'} />
          <References />
          <DocumentDate date={creditNote.creditNote_date} styles={styles} />
        </View>
        <View>
          <CustomerAddress styles={styles} company={company} customer={customer} />
          <Subject styles={styles} document={creditNote} />
        </View>
        <View fixed>
          <TableHead styles={styles} headers={baseDocument} />
        </View>
        <View style={{ flex: 0.8, marginBottom: '5px', paddingBottom: '10px' }}>
          <TableBody headers={baseDocument} lines={creditNote.lines} styles={styles} />
          <TableTotal total={creditNote.total_amount_net} styles={styles} company={company} />
          <CreditNotePayment />
        </View>
        <Footer company={company} styles={styles} />
      </Page>
      <CGV customer={customer} company={company} styles={styles} />
    </Document>
  )
}

export default React.memo(CreditNotePDF)
